document.addEventListener('DOMContentLoaded', () => {
  // const slideshowContent = document.querySelectorAll('.ds-image-link-blocks__item-media');
  // if (slideshowContent) {
  //   slideshowContent.forEach(item => {
  //     const content = item.querySelector('.ds-slideshow-split__content');
  //     item.addEventListener('mouseover', (event) => {
  //       event.preventDefault();
  //       item.classList.add('visible');
  //       if (content) {
  //         content.classList.remove('hidden');
  //       }
  //     });

  //     item.addEventListener('mouseout', (event) => {
  //       event.preventDefault();
  //       item.classList.remove('visible');
  //       if (content) {
  //         content.classList.add('hidden');
  //       }
  //     });
  //   });
  // }

  window.addEventListener('load', function() {
    const slideshowSplitHeading = document.querySelector('.ds-slideshow-split-item__heading');
    const slideshowSplitHeadingHeight = slideshowSplitHeading.offsetHeight;
    
    document.documentElement.style.setProperty('--slideshowSplit-title-height', slideshowSplitHeadingHeight + 'px');
  
    // Füge den CSS-Stil für .ds-slideshow-split__content-wrapper hinzu
    const style = document.createElement('style');
    style.textContent = `
      .ds-slideshow-split__content-wrapper {
        transform: translateY(calc(100% - var(--slideshowSplit-title-height) + var(--spacing-10) - 15px)) !important;
        transition: 0.6s;
      }
    `;
    document.head.appendChild(style);
  
    // Optional: Trigger reflow to ensure the transition works
    const contentWrapper = document.querySelector('.ds-slideshow-split__content-wrapper');
    if (contentWrapper) {
      contentWrapper.offsetHeight;
    }
  });
  
  
});